import styled, { css } from "styled-components";

export const Span = styled.span`
  ${({ req }) =>
    req &&
    css`
      &::after {
        content: " *";
        color: red;
      }
    `}
`;
